import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import AddEditPatientDetails from './AddEditPatientDetails';

import './PatientCard.scss';

class PatientCard extends Component {
  getGenderText = gender => {
    switch (gender) {
      case "M":
        return 'Male';
      case "F":
        return 'Female';
      case "O":
        return 'Others';
      default:
        return 'Others';
    }
  }

  selectPatient = () => {
    const { selectPatient, patientData } = this.props;
    selectPatient(patientData);
  }

  editPatientClicked = ev => {
    const { editPatientClicked, patientData } = this.props;
    ev.stopPropagation();
    editPatientClicked(patientData);
  }

  deletePatient = ev => {
    const { deletePatient, patientData } = this.props;
    ev.stopPropagation();
    deletePatient(patientData);
  }

  render() {
    // const enabledRadio = 'https://pe-web-assets.s3.amazonaws.com/images/prescriptions/radio_button_enabled.svg';
    // const disabledRadio = 'https://pe-web-assets.s3.amazonaws.com/images/prescriptions/radio_button_disabled.svg';
    const { patientData, selectedPatient } = this.props;
    const isSelected = patientData.id === selectedPatient.id;
    return (
      <div className="patientContainer" onClick={this.selectPatient}>
        <div className="patientHeader">
          <div className="patientHeaderName">{patientData.name}</div>
          <input
            type="radio"
            name="patient"
            value={patientData}
            checked={isSelected}
            onClick={this.selectPatient}
          />
        </div>
        <div className="patientDetails">
          <div className="subtext">Age: {patientData.age}</div>
          <div className="subtext">Gender: {this.getGenderText(patientData.gender)}</div>
        </div>
        <div>
          <span className="btnTextEdit" onClick={this.editPatientClicked}>Edit</span>
          <span className="btnTextDelete" onClick={this.deletePatient}>Delete</span>
        </div>
      </div>
    );
  }
}
PatientCard.propTypes = {
  patientData: PropTypes.object,
  selectedPatient: PropTypes.object,
  selectPatient: PropTypes.func,
  editPatientClicked: PropTypes.func,
  deletePatient: PropTypes.func,
};
PatientCard.defaultProps = {
  patientData: {},
  selectedPatient: {},
  selectPatient: () => null,
  editPatientClicked: () => null,
  deletePatient: () => null,
};
export default PatientCard;
